const ENDPOINT_MODIFIER_FOR_OPERATION = {
  search: [
    'searchProducts',
    'searchProductsForStore',
    'searchAutocompleteForUsers',
    'searchUsers'
  ],
  filters: [
    'searchAggregations',
    'searchAggregationsForStore',
    'searchSizes',
    'searchSizesForStore',
    'searchSubCategory',
    'searchSubCategoryForStore',
    'searchAutocompleteForProducts'
  ]
}

export function getEndpointModifierForOperation(operationName) {
  let modifier = null

  Object.keys(ENDPOINT_MODIFIER_FOR_OPERATION).some(key => {
    if (ENDPOINT_MODIFIER_FOR_OPERATION[key].indexOf(operationName) > -1) {
      modifier = key
      return true
    }
  })

  return modifier
}
